import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

export type ResearchTemplateProps = {
  eyebrow?: ReactNode;
  /** The question the research answers, as the H1. */
  title: ReactNode;
  /** A Byline with the data cut-off in its extra slot. */
  byline?: ReactNode;
  /** Three StatTiles: the headline figure, the change, the sample. */
  stats?: ReactNode;
  /** One ResearchPanel (or chart) per finding, on shared scales, with Prose between. */
  children: ReactNode;
  /** The method, as an Accordion. */
  method?: { title: ReactNode; content: ReactNode };
  className?: string;
};

/** Research reports and data articles (Data Desk editions, market and salary reports). Every chart states its sample. */
export function ResearchTemplate({
  eyebrow,
  title,
  byline,
  stats,
  children,
  method,
  className,
}: ResearchTemplateProps) {
  return (
    <PageContainer width="default" className={className}>
      <article className="mx-auto flex max-w-4xl flex-col gap-jc-block py-jc-section">
        <header className="flex flex-col gap-3">
          {eyebrow ? <span className="type-eyebrow text-jc-ink-secondary">{eyebrow}</span> : null}
          <h1 className="type-display text-jc-ink">{title}</h1>
          {byline}
        </header>
        {stats ? <div className="grid gap-3 sm:grid-cols-3">{stats}</div> : null}
        <div className="flex flex-col gap-jc-block">{children}</div>
        {method ? (
          <TemplateSection id="method" title={method.title}>
            {method.content}
          </TemplateSection>
        ) : null}
      </article>
    </PageContainer>
  );
}
